import * as React from 'react';

function IconNft(props) {
  return (
    <svg width={24} height={25} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.614 11.671l.613.235-.613-.235a1.094 1.094 0 001.022 1.485h2.727v7.02c0 .604.49 1.094 1.094 1.094h3.564v.855c0 .846.686 1.531 1.532 1.531h8.663c.846 0 1.531-.685 1.531-1.531V2.875c0-.846-.685-1.531-1.531-1.531H6.62c-.634 0-1.203.391-1.43.984l-3.577 9.344z"
        stroke="currentColor"
        strokeWidth={1.313}
        fill="none"
      />
      <path
        d="M5.898 17.034h3.05c1.396 0 2.723-.61 3.631-1.67v0M14.011 6.852s-1.282 1.432-2.863 1.432c-1.582 0-2.864-1.432-2.864-1.432"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.313}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default IconNft;
